import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {getProductCatalogPath} from 'modules/product-card/helpers';
import {useMemo} from 'react';
import {getProductCharacteristics} from 'modules/product-card/helpers/characteristics';

export const useDetailedCharacteristicsListState = () => {
    const productData = useAppSelector(selectProductData);
    const linkRoot = productData ? `${getProductCatalogPath(productData)}/filter/` : undefined;

    const detailedCharacteristics = useMemo(() => {
        if (!productData) {
            return [];
        }
        return getProductCharacteristics(productData, 'DETAILED', undefined, undefined, undefined, linkRoot);
    }, [linkRoot, productData]);

    const tabletCharacteristics = useMemo(() => {
        if (!productData) {
            return [];
        }
        return getProductCharacteristics(productData, 'TABLET', undefined, undefined, undefined, linkRoot);
    }, [linkRoot, productData]);

    return {detailedCharacteristics, tabletCharacteristics};
};
